import React from 'react';

const AVATAR_COLORS = [
  'linear-gradient(135deg, #6C5CE7, #a29bfe)',
  'linear-gradient(135deg, #00B894, #55efc4)',
  'linear-gradient(135deg, #E17055, #fab1a0)',
  'linear-gradient(135deg, #0984e3, #74b9ff)',
  'linear-gradient(135deg, #fdcb6e, #f39c12)',
];

function getInitials(user) {
  const name = user.username || user.fullName || user.name || '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

function getAvatarColor(index) {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
}

export default function PayrollSidebar({ users, selectedUser, onUserClick, searchTerm, onSearchChange, getUserId }) {
  return (
    <aside className="pr-sidebar">
      <div className="pr-sidebar-header">
        <div className="pr-sidebar-title">Employees</div>
        <div className="pr-search-wrap">
          <span className="pr-search-icon">&#128269;</span>
          <input
            className="pr-search"
            type="text"
            placeholder="Search staff..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className="pr-staff-list">
        {users.map(function (u, idx) {
          var uid = getUserId(u);
          var isActive = selectedUser && (getUserId(selectedUser) === uid);
          return (
            <div
              key={uid || idx}
              className={'pr-staff-card' + (isActive ? ' active' : '')}
              onClick={function () { onUserClick(u); }}
            >
              <div
                className="pr-avatar"
                style={{ background: getAvatarColor(idx) }}
              >
                {getInitials(u)}
              </div>
              <div className="pr-staff-info">
                <div className="pr-staff-name">{u.username || u.fullName || u.name}</div>
                <div className="pr-staff-role">{(u.roles && u.roles[0]) || u.email || ''}</div>
              </div>
            </div>
          );
        })}
        {users.length === 0 && (
          <div style={{ padding: 16, textAlign: 'center', color: '#636e72', fontSize: '0.82rem' }}>
            No employees found
          </div>
        )}
      </div>
    </aside>
  );
}
